export default {
  save: 'Enregistrer',
  cancel: 'Annuler',
  loading: 'Chargement...',
  notNow: 'Pas Maintenant',
  error: 'Erreur',
  error_occurred: 'Une erreur s\'est produite',
  success: 'Succès',
  warning: 'Avertissement',
  info: 'Information',
  confirm: 'Confirmer',
  delete: 'Supprimer',
  edit: 'Modifier',
  close: 'Fermer',
  back: 'Retour',
  next: 'Suivant',
  previous: 'Précédent',
  search: 'Rechercher',
  filter: 'Filtrer',
  clear: 'Effacer',
  apply: 'Appliquer',
  saveSuccess: 'Enregistré avec succès',
  saveError: 'Échec de l\'enregistrement',
  deleteSuccess: 'Supprimé avec succès',
  deleteError: 'Échec de la suppression',
  uploadSuccess: 'Téléchargé avec succès',
  uploadError: 'Échec du téléchargement',
  fetchError: 'Échec du chargement des données',
  page: 'Page',
  of: 'de',
  notProvided: 'Non fourni',
  notAvailable: 'Non disponible',
  backToResources: 'Retour aux Ressources',
  backToBorrowings: 'Retour aux Emprunts',
  backToList: 'Retour à la Liste',
  goBack: 'Retour',
  create: 'Créer',
  update: 'Mettre à jour',
  actions: 'Actions',
  retry: 'Réessayer',
  saving: 'Enregistrement...',
  deleting: 'Suppression...',
  noImage: 'Pas d\'image',
  images: 'Images',
  moreOptions: 'Plus d\'options',
  not_specified: 'Non spécifié',

  // Error management system translations
  networkError: 'Erreur réseau. Vérifiez votre connexion.',
  badRequest: 'Données de requête invalides',
  unauthorized: 'Authentification requise',
  forbidden: 'Accès refusé',
  notFound: 'Ressource introuvable',
  conflict: 'Conflit avec les données existantes',
  payloadTooLarge: 'Fichier ou données trop volumineux',
  validationError: 'Veuillez vérifier votre saisie',
  tooManyRequests: 'Trop de requêtes. Veuillez réessayer plus tard.',
  serverError: 'Erreur serveur. Veuillez réessayer plus tard.',
  serviceUnavailable: 'Service temporairement indisponible',
  unexpectedError: 'Erreur inattendue',

  // IntegerInput component
  switch_to_input_mode: 'Passer en mode saisie',
  switch_to_wheel_mode: 'Passer en mode roulette',
};
